import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import HeaderSectionTwo from "../components/head-section-two";
import DiscountIcon from '@mui/icons-material/Discount';
import { useHistory } from "react-router-dom";
import listProduct from '../components/product.json'
const Product = (props) =>{
    const history = useHistory()
    return (
        <div id="item_img"
        onClick={(()=>{
            history.push({
                pathname:`/product/:${props.data.name}`,
                state:{
                    product:props.data
                }
            })
         })} 
        >
        <DiscountIcon id="wish_product_icon" style={{color:"#CBAD61"}} />
        <img src={props.data.imgs[2]} alt=""/>
        <hr id="line_grid_3_system_img"/>
        <p id="item_img_title">{props.data.name}</p>
        <p id="item_img_price"><del id="underline_in_p">$560</del> <b style={{color:"black"}}>{props.data.price}</b></p>
        </div>
    )
}
const SpecialOffer = () =>{
    document.body.style.backgroundColor = "white"
    return (
        <div>
            <Header whihOne="specialoffers" />
            <HeaderSectionTwo title="Special Offers" smallTitle="Home / Special  /" usmallTitle="Offers Without Profit" />
               <section id="section_shop">
                    <div id="grid_4_cart">
                        {
                            listProduct.map((v,k)=>{
                                return <Product key={k} data={v}/>
                            })
                        }
                    </div>       
               </section>

            <Footer />
        </div>
    )
}
export default SpecialOffer;
